import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { InputText } from 'primereact/inputtext'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import Button from 'Components/UIComponent/Button'

const ForwardMessageModal = (props) => {
  const { setSelectedCommunitiesForForward, selectedCommunitiesForForward, filteredGroupList, setForwardSearchTerm, forwardSearchTerm, handleForwardToCommunity, isForwarding, setForwardModalVisible, forwardModalVisible, setMessageToForward, isAdminUser } = props
  const { t } = useTranslation()

  const isCommunityDisabled = (community) => community?.admin_only_message && !isAdminUser

  const handleCommunityCheckboxChange = (communityId) => {
    // Ignore "Create Your Own Community" slots
    const target = filteredGroupList?.find((c) => c.id === communityId)

    if (target?.isCreateOwn) return

    const community = (filteredGroupList || []).find((item) => item.id === communityId)

    if (isCommunityDisabled(community)) return

    setSelectedCommunitiesForForward((prev) => {
      if (prev.includes(communityId)) {
        return prev.filter((id) => id !== communityId)
      }

      return [...prev, communityId]
    })
  }

  const handleCloseForwardModal = () => {
    setForwardModalVisible(false)
    setMessageToForward(null)
    setSelectedCommunitiesForForward([])
  }

  const handleSelectAll = () => {
    const filteredCommunities = (filteredGroupList || [])?.filter((item) => !item.isCreateOwn && item.name?.toLowerCase().includes((forwardSearchTerm || '').toLowerCase()))
    const eligibleCommunities = filteredCommunities?.filter((item) => !isCommunityDisabled(item))
    const eligibleIds = eligibleCommunities?.map((item) => item.id) || []
    const allSelected = eligibleIds.length > 0 && eligibleIds.every((id) => selectedCommunitiesForForward?.includes(id))

    if (allSelected) {
      // Deselect all filtered communities
      setSelectedCommunitiesForForward((prev) => prev.filter((id) => !eligibleIds.includes(id)))
    } else {
      // Select all filtered communities
      setSelectedCommunitiesForForward((prev) => {
        const newSelection = [...prev]

        eligibleIds?.forEach((id) => {
          if (!newSelection.includes(id)) {
            newSelection.push(id)
          }
        })

        return newSelection
      })
    }
  }

  const renderForwardModalBody = () => {
    const filteredCommunities = (filteredGroupList || [])?.filter((item) => !item.isCreateOwn && item.name?.toLowerCase().includes((forwardSearchTerm || '').toLowerCase()))
    const eligibleCommunities = filteredCommunities?.filter((item) => !isCommunityDisabled(item))
    const eligibleIds = eligibleCommunities?.map((item) => item.id) || []
    const allSelected = eligibleIds.length > 0 && eligibleIds.every((id) => selectedCommunitiesForForward?.includes(id))

    return (
      <div className="forward-modal-body">
        <div className="search-section">
          <InputText placeholder="Search communities" value={forwardSearchTerm} onChange={(e) => setForwardSearchTerm(e?.target?.value)} className="input-field" />
        </div>

        <div className="selected-info">
          <div className="selected-count">
            Selected: {selectedCommunitiesForForward?.length} communit
            {selectedCommunitiesForForward?.length !== 1 ? 'ies' : 'y'}
          </div>
          <div className="select-all-container">
            Select All <input type="checkbox" checked={allSelected} onChange={handleSelectAll} className="select-all-checkbox" disabled={eligibleCommunities?.length === 0} />
          </div>
        </div>

        <div className="forward-list">
          {filteredCommunities?.length === 0 ? (
            <div className="no-results">No results found</div>
          ) : (
            filteredCommunities?.map((item) => {
              const disabled = isCommunityDisabled(item)

              return (
                <div key={item?.id} className={`forward-list-item ${selectedCommunitiesForForward?.includes(item?.id) ? 'selected' : ''} ${disabled ? 'disabled' : ''}`} onClick={() => handleCommunityCheckboxChange(item?.id)}>
                  <div className="community-info">
                    {item?.community_url ? <img src={item?.community_url} alt={item?.name} className="community-avatar" /> : <div className="community-placeholder">{item?.name?.[0]}</div>}
                    <div className="community-name">
                      <div>{item?.name}</div>
                      {disabled && <span className="admin-only-tag">Admin only messages</span>}
                    </div>
                  </div>
                  <input type="checkbox" checked={selectedCommunitiesForForward?.includes(item?.id)} onChange={() => handleCommunityCheckboxChange(item?.id)} onClick={(e) => e.stopPropagation()} className="forward-checkbox" disabled={disabled} />
                </div>
              )
            })
          )}
        </div>
      </div>
    )
  }

  const renderForwardModalFooter = () => (
    <div className="forward-modal-footer">
      <Button buttonType="CLOSE" onButtonClick={handleCloseForwardModal} />
      <Button buttonType="CUSTOM" buttonLabel={t('FORWARD')} onButtonClick={() => handleForwardToCommunity((filteredGroupList || []).filter((c) => !c.isCreateOwn).filter((c) => selectedCommunitiesForForward?.includes(c.id)))} disabled={isForwarding || selectedCommunitiesForForward?.length === 0} />
    </div>
  )

  return (
    <div>
      <DialogUIModal title={t('FORWARD_MESSAGE')} showModal={forwardModalVisible} handleClose={handleCloseForwardModal} bodyContent={renderForwardModalBody} footerContent={renderForwardModalFooter} customClassName="forward-message-modal" />
    </div>
  )
}

export default ForwardMessageModal
